import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { TRANSLATIONS, TRANSLATIONS_FORMAT, mergeApplicationConfig, ApplicationConfig } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';
import '@angular/localize/init';
import 'zone.js';
import { appConfig } from './app.config';

declare const require: any;
const currentLng = 'en';
let translations = '';

try {
  translations = require(`raw-loader!./locale/messages.${currentLng}.xlf`);
} catch (e) {
  console.warn('Translation file not found or loader error', e);
}

if (typeof window !== 'undefined') {
  Sentry.init({
    dsn: 'https://d32581c04bbe481b812f4b5b13e54663@sentry.io/1244426',
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
      new Sentry.Replay(),
    ],
    enabled: environment.production,
    release: environment.gitHash,
    tracesSampleRate: environment.production ? 0.5 : 1.0,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 0.5,
    maxBreadcrumbs: 50,
    beforeSendTransaction(transaction) {
      const hasMultipleProfileCalls = transaction.spans?.some(span => 
        span.description?.includes('/api/user/') && span.description?.includes('/profile')
      );

      if (hasMultipleProfileCalls) {
        return null;
      }

      return transaction;
    },
  });
}

const i18nConfig: ApplicationConfig = {
  providers: [
    { provide: TRANSLATIONS, useValue: translations },
    { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' }
  ]
};

bootstrapApplication(AppComponent, mergeApplicationConfig(appConfig, i18nConfig))
  .catch((err) => console.error(err));